module.exports = __webpack_public_path__ + "assets/media/information_swallow.1bcde41d.mp4";